import { calculateAge } from "../pages/contact/calculateAge";

export type FieldBehaviour = (
  value: unknown,
  values: Record<string, unknown>
) => unknown;

/**
 * Side effects a field can trigger on change, addressed by name so page config
 * stays serialisable. The config's `target` decides where the result goes.
 */
export const fieldBehaviours: Record<string, FieldBehaviour> = {
  calculateAge: (value) => calculateAge(value as string),
};

/** Filled from each record definition's own behaviours, by recordDefinitions. */
export function registerFieldBehaviours(
  behaviours: Record<string, FieldBehaviour> | undefined
) {
  Object.assign(fieldBehaviours, behaviours);
}

/** Undefined for an unknown name, so an older build still renders the page. */
export function getFieldBehaviour(
  name: string | undefined
): FieldBehaviour | undefined {
  return name ? fieldBehaviours[name] : undefined;
}
